import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns the tasks that carry a note, regardless of status. The note badge is shown
 * wherever a task has a note (it is added when a task is rescheduled and persists
 * through later status changes).
 */
@Pipe({
  standalone: false,
    name: 'rescheduledNotes'
})
export class RescheduledNotesPipe implements PipeTransform {
    transform(tasks: any[]): any[] {
        if (!tasks || !Array.isArray(tasks)) {
            return [];
        }
        return tasks.filter(task =>
            task && typeof task.note === 'string' && task.note.trim().length > 0
        );
    }
}
